import { createReducer, on } from '@ngrx/store';
import { Action } from 'rxjs/internal/scheduler/Action';
import { CustomManufacturerCampaignOverview, ManufacturerCampaignResultsData, ManufacturerCampaignSalesNotification } from '../custom-manufacturer-campaign.models';
import * as CustomManufacturerCampaignActions from "./custom-manufacturer-campaign.actions";

export const customManufacturerCampaignFeatureKey = 'customManufacturerCampaign';

export const CUSTOM_MANUFACTURER_CAMPAIGN_OVERVIEW = 'customManufacturerCampaignOverview';
export const CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS = 'customManufacturerCampaignDetails';
export const CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_DELETE = 'customManufacturerCampaignDetailsDelete';
export const CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_UPDATE = 'customManufacturerCampaignDetailsUpdate';

export interface CustomManufacturerCampaignState {
    [CUSTOM_MANUFACTURER_CAMPAIGN_OVERVIEW]: {
      manufacturerCampaignOverview: CustomManufacturerCampaignOverview;
      isLoading: boolean;
      error?: Error;
    };
    [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS]: {
      manufacturerCampaignDetails: ManufacturerCampaignSalesNotification[];
      isLoading: boolean;
      error?: Error;
    };
    [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_DELETE]: {
      isRunning: boolean;
      success: boolean;
      error?: boolean;
    };
    [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_UPDATE]: {
      isRunning: boolean;
      success: boolean;
      error?: boolean;
      message?: ManufacturerCampaignResultsData[]
    };
}

export const initialState: CustomManufacturerCampaignState = {
    [CUSTOM_MANUFACTURER_CAMPAIGN_OVERVIEW]: {
      manufacturerCampaignOverview: null,
      isLoading: false,
      error: null,
    },
    [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS]: {
      manufacturerCampaignDetails: null,
      isLoading: false,
      error: null,
    },
    [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_DELETE]: {
      isRunning: false,
      success: false,
      error: false,
    },
    [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_UPDATE]: {
      isRunning: false,
      success: false,
      error: false,
      message: null
    },
};

export const customManufacturerCampaignReducer = createReducer(
    initialState,
    on(CustomManufacturerCampaignActions.getManufacturerCampaign,
      (state) => ({
        ...state,
        [CUSTOM_MANUFACTURER_CAMPAIGN_OVERVIEW]: {
          manufacturerCampaignOverview: null,
            isLoading: true,
            error: null,
        },
    })),
    on(CustomManufacturerCampaignActions.getManufacturerCampaignSuccess,
      (state, action) => ({
        ...state,
        [CUSTOM_MANUFACTURER_CAMPAIGN_OVERVIEW]: {
          manufacturerCampaignOverview: action.manufacturercampaignOverview,
          isLoading: false,
          error: null,
        },
      })
    ),
    on(CustomManufacturerCampaignActions.getManufacturerCampaignFailure,
      (state, action) => ({
        ...state,
        [CUSTOM_MANUFACTURER_CAMPAIGN_OVERVIEW]: {
          manufacturerCampaignOverview: null,
          isLoading: false,
          error: action.error,
        },
      })
    ),
    //******************************************************
    on(CustomManufacturerCampaignActions.getManufacturerCampaignDetails,
      (state) => ({
        ...state,
        [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS]: {
            manufacturerCampaignDetails: null,
            isLoading: false,
            error: null,
        },
    })),
    on(CustomManufacturerCampaignActions.getManufacturerCampaignDetailsSuccess,
      (state, action) => ({
        ...state,
        [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS]: {
          manufacturerCampaignDetails: action.manufacturerCampaignDetails,
          isLoading: false,
          error: null,
        },
      })
    ),
    on(CustomManufacturerCampaignActions.getManufacturerCampaignDetailsFailure,
      (state, action) => ({
        ...state,
        [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS]: {
          manufacturerCampaignDetails: null,
          isLoading: false,
          error: action.error,
        },
      })
    ),
    //******************************************************
    on(CustomManufacturerCampaignActions.deleteSalesNotification,
      (state) => ({
        ...state,
        [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_DELETE]: {
          isRunning: true,
          success: false,
          error: false,
        },
      })
    ),
    on(CustomManufacturerCampaignActions.deleteSalesNotificationSuccess,
      (state) => ({
        ...state,
        [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_DELETE]: {
          isRunning: false,
          success: true,
          error: false,
        },
      })
    ),
    on(CustomManufacturerCampaignActions.deleteSalesNotificationFailure,
      (state) => ({
        ...state,
        [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_DELETE]: {
          isRunning: false,
          success: false,
          error: true,
        },
      })
    ),
    on(CustomManufacturerCampaignActions.deleteSalesNotificationReset,
      (state) => ({
        ...state,
        [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_DELETE]: {
          isRunning: false,
          success: false,
          error: false,
        },
      })
    ),
    //******************************************************
    on(CustomManufacturerCampaignActions.updateSalesNotification,
      (state) => ({
        ...state,
        [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_UPDATE]: {
          isRunning: true,
          success: false,
          error: false,
          message: null
        },
      })
    ),
    on(CustomManufacturerCampaignActions.updateSalesNotificationSuccess,
      (state) => ({
        ...state,
        [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_UPDATE]: {
          isRunning: false,
          success: true,
          error: false,
          message: null
        },
      })
    ),
    on(CustomManufacturerCampaignActions.updateSalesNotificationFailure,
      (state, action) => ({
        ...state,
        [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_UPDATE]: {
          isRunning: false,
          success: false,
          error: true,
          message: action.errorMessage
        },
      })
    ),
    on(CustomManufacturerCampaignActions.updateSalesNotificationReset,
      (state) => ({
        ...state,
        [CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_UPDATE]: {
          isRunning: false,
          success: false,
          error: false,
          message: null
        },
      })
    ),
);